export default __webpack_public_path__ + "bdec2463ae57aaef3ce88a03d15373f2.png";